import React, { forwardRef } from 'react';
export const MenuItemLabel = (StyledMenuItemLabel) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledMenuItemLabel {...props} ref={ref}>
        {children}
      </StyledMenuItemLabel>);
});
export default MenuItemLabel;
